import { Link } from '@on3/ui-lib/components/Link';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';
import clsx from 'clsx';
import { useRouter } from 'next/router';

import styles from './PlayerRankingsNav.module.scss';

export const PlayerRankingsNav = () => {
  const { formatHref } = useDynamicRoute();
  const { query, asPath } = useRouter();
  const {
    rankingType,
    type,
    position,
    state,
  }: {
    rankingType?: string;
    type?: string;
    position?: string;
    state?: string;
  } = query;

  const isIndustry = rankingType?.includes('industry');
  const isIndustryComparison = asPath.includes('industry-comparison');

  const showIndustryComparison = !type?.includes('junior');

  return (
    <div className={styles.block}>
      <Link
        className={clsx({ [styles.active]: isIndustry })}
        href={formatHref({
          path: '/rivals/rankings/[rankingType]/[sport]/[year]/',
          params: {
            rankingType: 'industry-player',
          },
          query: {
            position,
            state,
          },
          options: {
            resetQuery: true,
          },
        })}
      >
        Rivals Industry
      </Link>
      <Link
        className={clsx({
          [styles.active]: !isIndustry && !isIndustryComparison,
        })}
        href={formatHref({
          path: '/rivals/rankings/[rankingType]/[sport]/[year]/',
          params: {
            rankingType: 'player',
          },
          query: {
            position,
            state,
          },
          options: {
            resetQuery: true,
          },
        })}
      >
        Rivals Ranking
      </Link>
      {showIndustryComparison && (
        <Link
          className={clsx({ [styles.active]: isIndustryComparison })}
          href={formatHref({
            path: '/rivals/rankings/industry-comparison/[sport]/[year]/',
            query: {
              position,
              state,
            },
            options: {
              resetQuery: true,
            },
          })}
        >
          Industry Comparison
        </Link>
      )}
    </div>
  );
};
